import styled from '@emotion/styled';
import { Box } from '@lightspeed/flame/Core';
import { Heading4 } from '@lightspeed/flame/Text';

export const MigrationToolBox = styled(Box)`
  flex-grow: 1;
  @media screen and (max-width: 1024px) {
    width: 100%;
  }
`;

export const MigrationToolCardHeading = styled(Heading4)`
  margin-bottom: 10px;
  @media screen and (min-width: 1024px) {
    flex-basis: 25%;
  }
`;
